import { DamageType } from "../damageType";
import { Direction } from "../direction";
import { STANDARD_MOVEMENT_TIME } from "../effects/movementEffect";
import { ParticleEffect } from "../effects/particleEffect";
import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import { ParticleType } from "../particleType";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { SlidingDoor } from "./slidingDoor";

export class SlidingGate extends SlidingDoor {
	static key = "SlidingGate";

	constructor(xy: XY, direction: Direction, doorId?: string) {
		super(xy, direction, doorId);
		this.damageMultipliers.set(DamageType.BUBBLE, 0);
		this.damageMultipliers.set(DamageType.TOXIC_GAS, 0);
		this.damageMultipliers.set(DamageType.ELECTRIC, 0);
	}

	static override initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const dir = (props?.direction as Direction | undefined) ?? Direction.E;
		const door = new SlidingGate(xy, dir, props?.group as string | undefined);
		board.putThing(door);
		return [door];
	}

	// Unlike SlidingDoor, the retracted panel stays solid and shootable — its shelter tile can be destroyed.
	override open(): void {
		super.open();
		this.blocksMovement = true;
	}

	override isHittable(): boolean {
		return true;
	}

	protected override getOpenAnimationTime(): number {
		return STANDARD_MOVEMENT_TIME;
	}

	protected override isDestructible(): boolean {
		return true;
	}

	override isGasPermeable(): boolean {
		return true;
	}

	protected override onZeroHp(source: Thing | null, type: DamageType | null): void {
		this.board!.addEffect(new ParticleEffect(this.xy, ParticleType.METAL_DEBRIS, 6));
		this.board!.stats.recordObstacleDestroyed();
		super.onZeroHp(source, type);
	}

	static deserialize(data: any): SlidingGate {
		const d = new SlidingGate(deserializeXY(data.xy), data.direction, data.doorId ?? undefined);
		d.restoreDoorFields(data);
		d.blocksMovement = true;
		return d;
	}
}
